module.exports = __webpack_public_path__ + "static/media/rupali_bawale.b2876e21.jpg";